if (!customElements.get('cart-drawer-recommendations')) {
  customElements.define(
    'cart-drawer-recommendations',
    class CartDrawerRecommendations extends HTMLElement {
      async connectedCallback () {
        const response = await fetch(`${window.routes.product_recommendations_url}?product_id=${this.productId}&limit=10&section_id=${this.sectionId}`)
        const div = document.createElement("div");
        div.innerHTML = await response.clone().text();

        const productRecommendationsElement = div.querySelector("cart-drawer-recommendations");
        if (productRecommendationsElement && productRecommendationsElement.hasChildNodes()) {
          this.innerHTML = productRecommendationsElement.innerHTML;
          // document.querySelector('cart-drawer-items').style.flex = 'none'
        } else {
          this.hidden = true;
          // document.querySelector('cart-drawer-items').style.flex = '1'
        }
      }

      get productId() {
        return this.getAttribute("product-id");
      }
      get sectionId() {
        return this.getAttribute("section-id");
      }
    })
}
